import React, { useState, useEffect } from "react";

export default function MonthView() {
  const fakeData = [];

  fakeData.push({
    mois: "Janvier",
    "1": { type: "presence", num: 10 },
    "2": { type: "absence", num: 2 },
    "3": { type: "aQualifier", num: 2 }
  });
  fakeData.push({
    mois: "Fevrier",
    "1": { type: "presence", num: 10 },
    "2": { type: "absence", num: 2 },
    "3": { type: "aQualifier", num: 2 }
  });

  fakeData.push({
    mois: "Mars",
    "1": { type: "presence", num: 10 },
    "2": { type: "absence", num: 2 },
    "3": { type: "aQualifier", num: 2 }
  });
  fakeData.push({
    mois: "Avril",
    "1": { type: "presence", num: 10 },
    "2": { type: "absence", num: 2 },
    "3": { type: "aQualifier", num: 2 }
  });

  const generateBadge = (type, num) => {
    if (type === "presence")
      return (
        <div className="bg-green-400 rounded-full text-white p-2 w-full h-8 my-1 text-center cursor-pointer">
          {num + " présences"}
        </div>
      );
    if (type === "absence")
      return (
        <div className="bg-blue-800 rounded-full text-white p-2 w-full h-8 my-1 text-center cursor-pointer">
          {num + " absences"}
        </div>
      );
    if (type === "aQualifier")
      return (
        <div className="bg-gray-200 border-2 border-blue-800 rounded-full text-blue-800 p-2 w-full h-8 my-1 text-center cursor-pointer">
          {num + " à qualifier"}
        </div>
      );
  };

  return (
    <div className="flex flex-col my-8">
      <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200 w-1/4">
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="px-6 py-3 w- border-b border-gray-200 text-left leading-4 text-lg font-medium text-gray-500 tracking-wider">
                  Mois
                </th>
                <th className="px-6 py-3 lg:w-1/5 w-1/6 border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Semaine 1
                </th>
                <th className="px-6 py-3 lg:w-1/5 w-1/6 border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Semaine 2
                </th>
                <th className="px-6 py-3 lg:w-1/5 w-1/6 border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Semaine 3
                </th>
                <th className="px-6 py-3 lg:w-1/5 w-1/6 border-b border-gray-200 text-left leading-4 lg:text-lg font-medium text-gray-500 tracking-wider">
                  Semaine 4
                </th>
              </tr>
            </thead>
            <tbody>
              {fakeData.map(month => (
                <tr className="hover:bg-gray-100 cursor-pointer text-gray-700 text-lg" key={"de"}>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-500">
                    {month.mois}
                  </td>
                  <td className="p-6 lg:w-1/5 w-1/6 whitespace-no-wrap border-b border-gray-200 leading-5">
                    {generateBadge(month["1"]["type"], month["1"]["num"])}
                    {generateBadge(month["2"]["type"], month["2"]["num"])}
                    {generateBadge(month["3"]["type"], month["3"]["num"])}
                  </td>
                  <td className="p-6 lg:w-1/5 w-1/6 whitespace-no-wrap border-b border-gray-200 leading-5">
                    {generateBadge(month["1"]["type"], month["1"]["num"])}
                    {generateBadge(month["2"]["type"], month["2"]["num"])}
                    {generateBadge(month["3"]["type"], month["3"]["num"])}
                  </td>
                  <td className="p-6 lg:w-1/5 w-1/6 whitespace-no-wrap border-b border-gray-200 leading-5">
                    {generateBadge(month["1"]["type"], month["1"]["num"])}
                    {generateBadge(month["2"]["type"], month["2"]["num"])}
                    {generateBadge(month["3"]["type"], month["3"]["num"])}
                  </td>
                  <td className="p-6 lg:w-1/5 w-1/6 whitespace-no-wrap border-b border-gray-200 leading-5">
                    {generateBadge(month["1"]["type"], month["1"]["num"])}
                    {generateBadge(month["2"]["type"], month["2"]["num"])}
                    {generateBadge(month["3"]["type"], month["3"]["num"])}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/presence/presence/MonthView.js